module.exports = __webpack_public_path__ + "static/media/bytt-no-20.4a605cbe.mp3";